import { useContext } from 'react';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { subDays, format } from 'date-fns';
import { TemporalContext } from '../context/TemporalController';

export default function TimeSlider() {
  const { currentTime, setCurrentTime } = useContext(TemporalContext);
  const minDate = subDays(new Date(), 30);
  const maxDate = new Date();
  const sliderMin = Math.floor(minDate.getTime() / 1000);
  const sliderMax = Math.floor(maxDate.getTime() / 1000);
  const sliderVal = Math.min(sliderMax, Math.max(sliderMin, Math.floor(currentTime.getTime() / 1000)));

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ px: 1, py: 0.5 }}>
        <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.65rem' }}>
          TIME
        </Typography>
        <DatePicker
          value={currentTime}
          onChange={(d) => d && setCurrentTime(d)}
          minDate={minDate}
          maxDate={maxDate}
          slotProps={{ textField: { size: 'small', sx: { width: '100%', mb: 0.5 } } }}
        />
        <Slider
          value={sliderVal}
          min={sliderMin}
          max={sliderMax}
          step={3600 * 6}
          onChange={(_, v) => setCurrentTime(new Date((v as number) * 1000))}
          sx={{ color: 'rgba(255,255,255,0.7)' }}
          aria-label="time-scrub"
        />
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.6rem' }}>
          {format(currentTime, 'yyyy-MM-dd HH:00')} UTC
        </Typography>
      </Box>
    </LocalizationProvider>
  );
}
